import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Button } from '../../../atom/Button/Button';
import { Input } from '../../../atom/Input/Input';
import { InputDecorator } from '../../../atom/InputDecorator/InputDecorator';
import { Modal } from '../../../atom/Modal/Modal';
import { Radio } from '../../../atom/Radio/Radio';
import type { CustomLinkOptions } from '../_utils/CustomLink';
interface LinkButtonProps {
  onClick: () => void;
  selectedOptions: CustomLinkOptions;
  onHrefChange: (href: CustomLinkOptions['href']) => void;
  onThemeChange: (theme: CustomLinkOptions['theme']) => void;
  onIsOutLinkChange: (isOutLink: boolean) => void;
  onSizeChange: (size: CustomLinkOptions['size']) => void;
  onSubmit: () => void;
}

/**
 * 에디터 툴바의 버튼으로 각종 링크 추가 가능
 */
export const LinkButton = t0 => {
  const $ = _c(49);
  const {
    onClick,
    selectedOptions,
    onHrefChange,
    onThemeChange,
    onIsOutLinkChange,
    onSizeChange,
    onSubmit
  } = t0;
  const [isModalOpened, setIsModalOpened] = useState(false);
  const isButtonSelected = selectedOptions.theme === "primary-fill-button" || selectedOptions.theme === "sub-fill-button" || selectedOptions.theme === "blue-fill-button";
  let t1;
  if ($[0] !== onClick) {
    t1 = <Button dimensions="H26" onClick={() => {
      setIsModalOpened(true);
      onClick();
    }}>링크</Button>;
    $[0] = onClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsModalOpened(false);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onHrefChange) {
    t3 = e => {
      onHrefChange(e.target.value);
    };
    $[3] = onHrefChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== selectedOptions.href || $[6] !== t3) {
    t4 = <InputDecorator label={"\uC8FC\uC18C"}><Input value={selectedOptions.href} onChange={t3} /></InputDecorator>;
    $[5] = selectedOptions.href;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Radio.Item value="text">문자</Radio.Item>;
    t6 = <Radio.Item value="primary-fill-button">검정 버튼</Radio.Item>;
    t7 = <Radio.Item value="sub-fill-button">회색 버튼</Radio.Item>;
    t8 = <Radio.Item value="blue-fill-button">파랑 버튼</Radio.Item>;
    t9 = <Radio.Item value="image">이미지</Radio.Item>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t10;
  if ($[13] !== onThemeChange || $[14] !== selectedOptions.theme) {
    t10 = <InputDecorator label={"\uB9C1\uD06C \uD615\uC2DD"}><Radio.Group value={selectedOptions.theme} onChange={onThemeChange}>{t5}{t6}{t7}{t8}{t9}</Radio.Group></InputDecorator>;
    $[13] = onThemeChange;
    $[14] = selectedOptions.theme;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = !isButtonSelected;
  let t12;
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Radio.Item value="H40">H40</Radio.Item>;
    t13 = <Radio.Item value="H56">H56</Radio.Item>;
    $[16] = t12;
    $[17] = t13;
  } else {
    t12 = $[16];
    t13 = $[17];
  }
  let t14;
  if ($[18] !== onSizeChange || $[19] !== selectedOptions.size || $[20] !== t11) {
    t14 = <InputDecorator label={"\uBC84\uD2BC \uC0AC\uC774\uC988"}><Radio.Group readOnly={t11} value={selectedOptions.size} onChange={onSizeChange}>{t12}{t13}</Radio.Group></InputDecorator>;
    $[18] = onSizeChange;
    $[19] = selectedOptions.size;
    $[20] = t11;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  const t15 = selectedOptions.isOutLink ? "out" : "in";
  let t16;
  if ($[22] !== onIsOutLinkChange) {
    t16 = value => {
      onIsOutLinkChange(value === "out");
    };
    $[22] = onIsOutLinkChange;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  let t18;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Radio.Item value="out">외부에서 열기</Radio.Item>;
    t18 = <Radio.Item value="in">내부에서 열기</Radio.Item>;
    $[24] = t17;
    $[25] = t18;
  } else {
    t17 = $[24];
    t18 = $[25];
  }
  let t19;
  if ($[26] !== t15 || $[27] !== t16) {
    t19 = <InputDecorator label={"\uCC3D \uC5F4\uAE30"}><Radio.Group value={t15} onChange={t16}>{t17}{t18}</Radio.Group></InputDecorator>;
    $[26] = t15;
    $[27] = t16;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t10 || $[30] !== t14 || $[31] !== t19 || $[32] !== t4) {
    t20 = <article className="mb-32 flex flex-col gap-16">{t4}{t10}{t14}{t19}</article>;
    $[29] = t10;
    $[30] = t14;
    $[31] = t19;
    $[32] = t4;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  const t21 = !selectedOptions.href;
  let t22;
  if ($[34] !== onSubmit) {
    t22 = () => {
      setIsModalOpened(false);
      onSubmit();
    };
    $[34] = onSubmit;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== t21 || $[37] !== t22) {
    t23 = <Button className="flex-1" disabled={t21} onClick={t22}>설정</Button>;
    $[36] = t21;
    $[37] = t22;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Button className="flex-1" theme="sub-fill" onClick={() => {
      setIsModalOpened(false);
    }}>취소</Button>;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== t23) {
    t25 = <footer className="flex w-full gap-8">{t23}{t24}</footer>;
    $[40] = t23;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== isModalOpened || $[43] !== t20 || $[44] !== t25) {
    t26 = <Modal opened={isModalOpened} onClose={t2}>{t20}{t25}</Modal>;
    $[42] = isModalOpened;
    $[43] = t20;
    $[44] = t25;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== t1 || $[47] !== t26) {
    t27 = <>{t1}{t26}</>;
    $[46] = t1;
    $[47] = t26;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  return t27;
};